"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleTypes = {
    'new': 0,
    used: 1,
    cpo: 2
};
